export default {"theme":{"themes":{"light":{"primary":"#0168A5","accent":"#F29100","secondary":"#1A9FDA","success":"#4CAF50","info":"#2196F3","warning":"#FB8C00","error":"#FF5252"}}}}
